import { render, staticRenderFns } from "./waterHistory.vue?vue&type=template&id=9c63b9e2&scoped=true&"
import script from "./waterHistory.vue?vue&type=script&lang=js&"
export * from "./waterHistory.vue?vue&type=script&lang=js&"
import style0 from "./waterHistory.vue?vue&type=style&index=0&id=9c63b9e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c63b9e2",
  null
  
)

export default component.exports